import { render, staticRenderFns } from "./quicklycoins.vue?vue&type=template&id=09f04db6"
import script from "./quicklycoins.vue?vue&type=script&lang=js"
export * from "./quicklycoins.vue?vue&type=script&lang=js"
import style0 from "./quicklycoins.vue?vue&type=style&index=0&id=09f04db6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports